/**
 * What the help chat's Contact support hands to /support through router state (help-center-chatbot BR-27):
 * the conversation as a subject and message to edit, or a flag saying the conversation could not be
 * attached. Nothing is sent until the landlord submits the contact form.
 */

import { CONTACT_MESSAGE_MAX_CHARS, CONTACT_SUBJECT_MAX_CHARS } from '@resida/api-types/support';

export type ContactHandoffState = { subject: string; body: string } | { attachFailed: true };

type ContactHandoff = { kind: 'attached'; subject: string; body: string } | { kind: 'failed' };

/** Reads the handoff out of untrusted router state; null when the landlord arrived some other way. */
export function readContactHandoff(state: unknown): ContactHandoff | null {
  if (typeof state !== 'object' || state === null) return null;
  const { subject, body, attachFailed } = state as { subject?: unknown; body?: unknown; attachFailed?: unknown };
  if (attachFailed === true) return { kind: 'failed' };
  if (typeof subject !== 'string' || typeof body !== 'string') return null;
  return {
    kind: 'attached',
    subject: subject.slice(0, CONTACT_SUBJECT_MAX_CHARS),
    body: body.slice(0, CONTACT_MESSAGE_MAX_CHARS),
  };
}
